const EMBED_HANDLE = "safegeo-embed";

type ExtensionActivation = { handle?: string; status?: string };
type AppExtension = {
  type?: string;
  activations?: ExtensionActivation[];
};

/**
 * App Bridge: theme embed active? Complements Nest GET /embed/status.
 */
export async function readEmbedViaAppBridge(): Promise<boolean | null> {
  try {
    const shopify = window.shopify as
      | { app?: { extensions?: () => Promise<AppExtension[]> } }
      | undefined;
    if (!shopify?.app?.extensions) return null;
    const extensions = await shopify.app.extensions();
    const theme = (extensions || []).filter(
      (e) => e.type === "theme_app_extension",
    );
    const active = theme.some((ext) =>
      (ext.activations || []).some(
        (block) =>
          block.handle === EMBED_HANDLE && block.status === "active",
      ),
    );
    const known = theme.some((ext) =>
      (ext.activations || []).some((block) => block.handle === EMBED_HANDLE),
    );
    if (!known && theme.length === 0) return null;
    return active;
  } catch {
    return null;
  }
}
